import { useOnValueChange } from '@calendly/hooks'
import { compact } from 'lodash-es'
import { Children, cloneElement, useCallback, useRef } from 'react'

import { useAccordion } from './context'
import { toggleKey } from './reducer'

export const Accordion = ({ children, onPanelToggle, disabled, ...props }) => {
  const { dispatch, selectedKeys } = useAccordion()
  const isInitialRender = useRef(true)

  useOnValueChange(selectedKeys, () => {
    if (isInitialRender.current) { isInitialRender.current = false }
  })

  const onSelected = useCallback((panelKey) => {
    if (isInitialRender.current) { isInitialRender.current = false }

    if (onPanelToggle) {
      return onPanelToggle(() => dispatch(toggleKey(panelKey)))
    }

    return dispatch(toggleKey(panelKey))
  }, [dispatch, onPanelToggle])

  return (
    <div {...props}>
      {
        Children.map(compact(children), (panel) => cloneElement(panel, {
          key: panel.props.panelKey,
          disabled,
          onSelected,
          expand: selectedKeys.includes(panel.props.panelKey),
          skipAnimation: isInitialRender.current,
        }))
      }
    </div>
  )
}
